import Modal from "../Modal/Modal";
import { useState } from "react";
import "./addTask.css";
import { db } from "../../../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

function AddTask({ onClose, open }) {
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [age, setAge] = useState("");
  const [city, setCity] = useState("");
  const [followers, setFollowers] = useState("");

  /* function to add new task to firestore */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "users"), {
        name: name,
        surname: surname,
        username: username,
        email: email,
        followers: followers,
        age: age,
        city: city,
        completed: false,
        created: Timestamp.now(),
      });
      onClose();
    } catch (err) {
      alert(err);
    }
  };

  return (
    <Modal modalLable="Add Task" onClose={onClose} open={open}>
      <form onSubmit={handleSubmit} className="addTask" name="addTask">
        <label>Name</label>
        <input
          type="text"
          name="name"
          onChange={(e) => setName(e.target.value.toUpperCase())}
          value={name}
          placeholder="Enter name"
        />
        <label>Surname</label>
        <input
          type="text"
          name="surname"
          onChange={(e) => setSurname(e.target.value)}
          value={surname}
          placeholder="Enter name"
        />
        <label>Age</label>
        <input
          type="text"
          name="age"
          onChange={(e) => setAge(e.target.value)}
          value={age}
          placeholder="Enter Age"
        />
        <label>Username</label>
        <input
          type="text"
          name="username"
          onChange={(e) => setUsername(e.target.value)}
          value={username}
          placeholder="Enter username"
        />
        <label>Email</label>
        <input
          type="text"
          name="email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          placeholder="Enter Email"
        />
        <label>Followers</label>
        <input
          type="text"
          name="followers"
          onChange={(e) => setFollowers(e.target.value)}
          value={followers}
          placeholder="Enter Followers"
        />
        <label>City</label>
        <input
          type="text"
          name="city"
          onChange={(e) => setCity(e.target.value)}
          value={city}
          placeholder="Enter name"
        />

        <button type="submit">Done</button>
      </form>
    </Modal>
  );
}

export default AddTask;
